import { useState, useCallback } from 'react';
import { notifyError } from '../components/Toast';
import { useSelector } from 'react-redux';

export const useDownloadEvaluacionesPdf = () => {
  const {user} = useSelector((state) => state.auth);
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState(null);

  const downloadPdf = useCallback(async ( processId, ugCod, sedeCod ) => {
    setIsDownloading(true);
    setError(null);

    try {
      const query = new URLSearchParams({ sede : sedeCod || '',}).toString();
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}reportes/${processId}/evaluaciones/${ugCod}/pdf?${query}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
      });

      if (!response.ok) {
        const errorMsg = `Error al descargar el PDF: ${response.statusText}`;
        throw new Error(errorMsg);
      }else{
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `evaluaciones-${ugCod}` + (sedeCod ? `-${sedeCod}` : ``) + `_${processId}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
      
    } catch (err) {
      notifyError(err.message || 'Error desconocido al descargar el PDF');
    } finally {
      setIsDownloading(false);
    }
  }, []);

  return { downloadPdf, isDownloading, error };
};
